/* eslint-disable */
import React, { Component, Fragment } from "react";
import Stats from "../Shared/Summary/Stats";
import Banner from "../Shared/Summary/Banner";
import ViewHistory from "../Shared/Summary/ViewHistory";
import RecentScores from "../../../recent-scores/components/RecentScores";
import StartTrialModal from "../../../../shared/components/modals/StartTrialModal";
import PropTypes from "prop-types";
import JoinChallengeModal from "../../../../shared/components/modals/JoinChallengeModal";
import JoinedChallengeModal from "../../../../shared/components/modals/JoinedChallengeModal";
import PostedScoreModal from "../../../../shared/components/modals/PostedScoreModal";
import golferApi from "../../../../services/golfer-api";
import { routesContext } from "../../../../shared/routes/routes-context";
import Box from "../../../../shared/components/box/Box";
import BoxHead from "../../../../shared/components/box/BoxHead";
import { Helmet } from "react-helmet";
import GolferApi from "../../../../services/golfer-api";
import { getUser } from "../../../../shared/helpers/user-helper";
import { setEvent } from "../../../../firebaseConfig";
import {
  RS_TOTAL_TITLE,
  RS_TOTAL_DESC,
} from "../../../../shared/variables/meta-seo";
import Loader from "../../../../shared/components/loaders/Loader";
import { formatDateRange } from "../../../challenges/utils";

class PostTotalScoreSummary extends Component {
  static contextType = routesContext;
  state = {
    trialModalOpen: false,
    modalTitle: "",
    modalContent: "",
    modalSubTitle: "",
    modalSubContent: "",
    icon: "",
    n_modalTitle: "",
    n_modalContent: "",
    n_modalSubTitle: "",
    n_modalSubContent: "",
    n_icon: "",
    next: false,
    thirdScorePosted: null,
    challengeModalOpen: false,
    joinedChallengeModalOpen: false,
    postedScoreModalOpen: false,
    challenge_details: null, // Challenge details will be stored here.
    golferName: "",
    canJoinChallenge: true,
  };

  componentDidMount = () => {
    const score = this.props.history.location.state.score;
    const golfer_id = score.golfer_id;
    if (score.challenge_available) {
      GolferApi.getChallengeDetails(score.id)
        .then((res) => {
          if (res.data) {
            this.setState({ challenge_details: res.data });
            if (res.data.joined) this.setState({ postedScoreModalOpen: true });
            else this.setState({ challengeModalOpen: true });
          }
        })
        .catch((error) => {
          console.error("Error fetching challenge details", error);
          this.setState({ canJoinChallenge: false });
        });
    }

    const user = getUser();
    this.setState({ golferName: `${user.first_name} ${user.last_name}` });

    GolferApi.checkTrial(golfer_id, "summary").then((r) => {
      if (r.data.days_left !== -1 && r.data.messages) {
        this.setState({
          modalTitle: r.data.messages[0].headline,
          modalContent: r.data.messages[0].copy,
          modalSubContent: r.data.messages[0].sub_copy,
          modalSubTitle: r.data.messages[0].sub_headline,
          icon: r.data.messages[0].icon,
          trialModalOpen: true,
        });
        if (r.data.messageCount === 2) {
          this.setState({
            n_modalTitle: r.data.messages[1].headline,
            n_modalContent: r.data.messages[1].copy,
            n_modalSubContent: r.data.messages[1].sub_copy,
            n_modalSubTitle: r.data.messages[1].sub_headline,
            n_icon: r.data.messages[1].icon,
            next: true,
            thirdScorePosted: true,
          });
        }
      }
    });
  };

  onConfirmChallengeModal = () => {
    const score = this.props.history.location.state.score;
    const challengeId = this.state.challenge_details
      ? this.state.challenge_details.id
      : score.challenge_details.id;
    golferApi
      .joinChallenge(score.golfer_id, challengeId)
      .then((r) => {
        this.setState({ joinedChallengeModalOpen: true });
      })
      .catch((error) => {
        console.error("Error during challenge joining", error);
      });
    this.setState({ challengeModalOpen: false });
  };

  onConfirmModal = () => {
    if (this.state.next) {
      this.setState({
        modalTitle: this.state.n_modalTitle,
        modalContent: this.state.n_modalContent,
        modalSubContent: this.state.n_modalSubContent,
        modalSubTitle: this.state.n_modalSubTitle,
        icon: this.state.n_icon,
        next: false,
      });
    } else {
      this.setState({
        trialModalOpen: false,
        challengeModalOpen: false,
        joinedChallengeModalOpen: false,
        postedScoreModalOpen: false,
      });
    }
    const user = getUser();
    setEvent(user, "Trial_Sign_Up_Click", "Screen_Name", "Pop_Up");
    window.open("https://getahandicap.usga.org");
  };

  onCloseModal = () => {
    if (this.state.next) {
      this.setState({
        modalTitle: this.state.n_modalTitle,
        modalContent: this.state.n_modalContent,
        modalSubContent: this.state.n_modalSubContent,
        modalSubTitle: this.state.n_modalSubTitle,
        icon: this.state.n_icon,
        next: false,
      });
    } else {
      this.setState({
        trialModalOpen: false,
        challengeModalOpen: false,
        joinedChallengeModalOpen: false,
        postedScoreModalOpen: false,
      });
    }
  };

  getScore = () => {
    const { history } = this.props;
    return history.location.state?.score || null;
  };

  getCourseDetails = () => {
    const { history } = this.props;
    return history.location.state?.courseDetails || null;
  };

  render = () => {
    const { challenge_details, canJoinChallenge } = this.state;

    // Show a loading state until challenge details are fetched.
    if (
      this.getScore().challenge_available &&
      !challenge_details &&
      canJoinChallenge
    ) {
      return <Loader />;
    }

    return (
      <Fragment>
        <Helmet>
          <title>{RS_TOTAL_TITLE}</title>
          <meta name="description" content={RS_TOTAL_DESC} />
        </Helmet>
        <Box>
          <BoxHead title="Round Summary" />
          <Banner />
          <Stats
            score={this.getScore()}
            courseDetails={this.getCourseDetails()}
            hideDeleteButton={this.state.thirdScorePosted}
            isAdvStatsOn={false}
          />
          <br />
          <br />
          <BoxHead title="Recent Scores" />
        </Box>
        <RecentScores defaultScoresPerPage={10} />
        <ViewHistory onViewScoreHistory={() => this.context.stats.navigate()} />
        <StartTrialModal
          title={this.state.modalTitle}
          content={this.state.modalContent}
          subtitle={this.state.modalSubTitle}
          subcontent={this.state.modalSubContent}
          icon={this.state.icon}
          isOpen={this.state.trialModalOpen}
          onConfirmModal={this.onConfirmModal}
          onCloseModal={this.onCloseModal}
        />
        {this.getScore().challenge_available && canJoinChallenge && (
          <>
            <JoinChallengeModal
              name={challenge_details.name}
              challengeId={challenge_details.id}
              challengeDate={formatDateRange(
                challenge_details.start_date,
                challenge_details.end_date
              )}
              upcomingChallenge={challenge_details.status === "upcoming"}
              golferId={this.props.history.location.state.score.golfer_id}
              isOpen={this.state.challengeModalOpen}
              onConfirmModal={this.onConfirmChallengeModal}
              onCloseModal={this.onCloseModal}
            />
            <JoinedChallengeModal
              title={`You joined the ${challenge_details.name}`}
              content={challenge_details.info?.message}
              challengeId={challenge_details.id}
              progress={challenge_details.progress}
              isOpen={this.state.joinedChallengeModalOpen}
              onConfirmModal={this.onCloseModal}
              onCloseModal={this.onCloseModal}
            />
            <PostedScoreModal
              title={challenge_details.info?.title}
              content={challenge_details.info?.message}
              name={challenge_details.name}
              subcontent={"subcontent"}
              progress={challenge_details.progress}
              score={challenge_details.score_posted}
              challengeId={challenge_details.id}
              scores={challenge_details.top_3_scores}
              totalNet={challenge_details.total_net_score_to_par}
              golferName={this.state.golferName}
              isOpen={this.state.postedScoreModalOpen}
              onConfirmModal={this.onCloseModal}
              onCloseModal={this.onCloseModal}
            />
          </>
        )}
      </Fragment>
    );
  };
}

PostTotalScoreSummary.propTypes = {
  history: PropTypes.object.isRequired,
};

export default PostTotalScoreSummary;
